import { render, staticRenderFns } from "./Recommended.vue?vue&type=template&id=4997e7e6&scoped=true"
import script from "./Recommended.vue?vue&type=script&lang=js"
export * from "./Recommended.vue?vue&type=script&lang=js"
import style0 from "./Recommended.vue?vue&type=style&index=0&id=4997e7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997e7e6",
  null
  
)

export default component.exports